
























































import { getCurrentInstance, defineComponent, watch, ref, onMounted } from '@vue/composition-api';
import { LogoutIcon } from 'tdesign-icons-vue';
import BaseIcon from '@/renderer/components/common/BaseIcon.vue';
import CreateEsign, {
  createDialogHandler,
} from '@/renderer/views/desktop/FileManagement/ElectronicSign/components/CreateEsign.vue';

// 引入工具类
import { DrawerEvents } from '@/renderer/store/modules/drawer';
import { IS_BROWSER } from '@/common/constant/index';
import '@/renderer/assets/images/Icon/svg/electronicSign/create-esign.svg';
import '@/renderer/assets/images/Icon/svg/electronicSign/esign-folder.svg';
import '@/renderer/assets/images/Icon/svg/electronicSign/esign-logo.svg';
import electronicSignHandler from './composition/listHandler';
export default defineComponent({
  components: {
    LogoutIcon,
    BaseIcon,
    CreateEsign,
  },
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const { $store } = vm;
    const { list, methods: eSignMethods } = electronicSignHandler();
    const { show: createShow, methods: createDialogMethods } = createDialogHandler();
    const templateItem = ref(null);
    const methods = {
      initData() {
        eSignMethods.pullList();
      },
      dispatchRouter(params: { name: string; query?: any; params?: any }) {
        vm.$router[IS_BROWSER ? 'push' : 'replace'](params).catch(() => {
          //
        });
      },
      onReturn() {
        const { previousRoute } = $store.getters;
        if (['doc', 'edit'].includes(previousRoute.name) || previousRoute.name === vm.$route.name) {
          methods.dispatchRouter({
            name: 'workbench',
          });
        } else {
          if (previousRoute.name === 'spaceStatistics') {
            methods.dispatchRouter({
              name: 'spaceStatistics',
            });
            return;
          }
          methods.dispatchRouter(previousRoute);
        }
      },
      quickUse(item: any) {
        createDialogMethods.open();
        templateItem.value = item;
      },
    };
    methods.initData();
    onMounted(() => {
      $store.commit(DrawerEvents.DESTORY_DRAWER);
    });
    return {
      ...methods,
      list,
      templateItem,
      createShow,
      createDialogMethods,
    };
  },
});
